import React from 'react';
import { Box, Button, Checkbox, Heading, Stack, Text } from '@chakra-ui/react';
import { AiOffer, BranchContext } from './types';
import { period, price } from './aiPlansApi';
export const AiPlanCheckout: React.FC<{
 offer: AiOffer; context: BranchContext; busy: boolean; error: string;
 onConfirm: () => void; onCancel: () => void;
}> = ({ offer, context, busy, error, onConfirm, onCancel }) => {
 const [accepted, setAccepted] = React.useState(false);
 return <Box borderWidth="1px" borderRadius="lg" p="5" mt="5" role="region" aria-label="Resumo da contratação">
  <Stack spacing="3">
   <Heading size="md">Confirme sua contratação</Heading>
   <Text>{context.branchName || 'Filial ' + context.branchId} · Empresa {context.companyId}</Text>
   <Text fontWeight="bold">{offer.name} — {price(offer)} {period(offer)}</Text>
   <Text>{offer.quota} {offer.unit} · {offer.performanceProfile}</Text>
   <Text>Cobrança automática ainda não habilitada. O aceite vincula o plano à filial. A cobrança futura dependerá de uma etapa própria, sem cobrança retroativa automática.</Text>
   <Checkbox isChecked={accepted} isDisabled={busy} onChange={event => setAccepted(event.target.checked)}>
    Confirmo o plano e as condições acima — termos {offer.termsVersion}, versão {offer.revision}.
   </Checkbox>
   {error && <Text role="alert" color="red.500">{error}</Text>}
   <Stack direction="row">
    <Button colorScheme="blue" isDisabled={!accepted || busy} onClick={onConfirm}>{busy ? 'Confirmando...' : 'Confirmar contratação'}</Button>
    <Button variant="ghost" isDisabled={busy} onClick={onCancel}>Voltar</Button>
   </Stack>
  </Stack>
 </Box>;
};
